module.exports = __webpack_public_path__ + "img/icon-search.94c064a9.svg";